import template from './dtts.html';
import controller from './dtts.controller';
import './dtts.scss';

let DttsComponent = {
  bindings: {
    dttsObservable: '<'
  },
  template,
  controller
};

export default DttsComponent;



// WEBPACK FOOTER //
// ./src/app/pages/dtts/dtts.component.js